import { useFeatureFlag } from '@/store/slices/api/featureFlagsApiSlice';

export const useBoxInclinicFeatureFlag = () => {
  const isBoxInclinicFeatureEnabled = useFeatureFlag('box_integration');

  return {
    isBoxInclinicFeatureEnabled
  };
};
